import axios from 'axios';
import $ from '@rover/globals/jquery';
import Rover from '@rover/globals/Rover';

const initJQueryHeaders = () => {
  $.ajaxSetup({ headers: Rover.api.getSourceHeader() });

  $(document).ajaxSend((e, jqxhr, settings) => {
    const token = Rover.utils.getCsrfToken();

    if (!token) return;

    if (window.isRoverURL(settings.url)) {
      jqxhr.setRequestHeader('X-CSRFToken', token);
    }
  });
};

const initAxiosHeaders = () => {
  axios.interceptors.request.use(
    config => {
      // if we're requesting a rover url
      if (
        config.url.includes(window.location.host) ||
        config.url.startsWith('/') ||
        config.url.startsWith('./') ||
        config.url.startsWith('../')
      ) {
        const clone = { ...config };
        // clone the config and add our custom headers
        clone.headers.common = {
          ...config.headers.common,
          ...Rover.api.getSourceHeader(),
        };
        const token = Rover.utils.getCsrfToken();
        if (token) {
          clone.headers.common['X-CSRFToken'] = token;
        }
        return clone;
      }
      // non-rover urls get NOTHING, to avoid CORS issues
      return config;
    },
    error => Promise.reject(error)
  );
};

function init() {
  initJQueryHeaders();
  initAxiosHeaders();
}

export default {
  init,
};



// WEBPACK FOOTER //
// ../utilities/ajax.js